// extracted by mini-css-extract-plugin
module.exports = {"sButton":"sButton_sButton__x_S3v","gleam":"sButton_gleam__ENLaO"};